import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gt-cors-settings',
  templateUrl: './gt-cors-settings.component.html',
  styleUrls: ['./gt-cors-settings.component.scss']
})
export class GtCorsSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
